export const GOOGLE_EVENT_NAMES = {
  addToCart: 'add_to_cart',
  beginCheckOut: 'begin_checkout',
  checkOutProgress: 'checkout_progress',
  purchase: 'purchase',
  removeFromCart: 'remove_from_cart',
  purchaseError: 'purchase_error',
  checkOutValidationError: 'checkout_validation_error'
};
